// extracted by mini-css-extract-plugin
export var cardContainer = "_p1-0";
export var cardHeader = "_p1-2";
export var collapsedState = "_p1-3";
export var dragHandle = "_p1-5";
export var dragHandleIcon = "_p1-6";
export var dragging = "_p1-1";
export var titleArea = "_p1-4";